import VInput from './VInput'

/* istanbul ignore next */
VInput.install = function install (Vue) {
  Vue.component(VInput.name, VInput)
}

export { VInput }
export default VInput
